import {HttpClient} from "../../service/httpClient/HttpClient";
import {setLoadingStateDispatch} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes} from "../../context/SnackBarContext";
import {ServerErrorHandler} from "../../service/httpClient/ServerErrorHandler";

export class ProfileService {
    loading;

    constructor(token, snackbar, loading) {
        this.loading = loading;
        this.snackbar = snackbar;
        this.token = token;

        this.httpClient = new HttpClient()
    }

    getManagerProfileInfo() {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                "fund-presentation/managers",
                this.httpClient.prepareUserAccessHeader(this.token)
            ).then(response => resolve(response))
                .catch(reason => reject(reason))
        })
    }

    changeManagerProfileInfo(data) {
        this.loading(setLoadingStateDispatch(true))


        this.httpClient.put(
            "fund-presentation/managers",
            this.httpClient.prepareUserAccessHeader(this.token),
            data
        ).then(response => {
            this.snackbar(
                setSnackbarDispatch(
                    SnackbarActionTypes.SHOW_SUCCESS,
                    "بروزرسانی اطلاعات کاربر با موفقیت انجام شد."))
            this.loading(setLoadingStateDispatch(false))
        }).catch(reason => {
            ServerErrorHandler(reason, "خطا در بروزرسانی اطلاعات کاربر",this.snackbar,this.loading)
        })
    }

    changeManagerProfilePassword(currentPassword, newPassword) {
        this.loading(setLoadingStateDispatch(true))

        this.httpClient.put(
            "fund-presentation/managers/password",
            this.httpClient.prepareUserAccessHeader(this.token),
            {
                "currentPassword": currentPassword,
                "newPassword": newPassword
            }
        ).then(response => {
            this.snackbar(
                setSnackbarDispatch(
                    SnackbarActionTypes.SHOW_SUCCESS,
                    "بروزرسانی رمز عبور با موفقیت انجام شد."))
            this.loading(setLoadingStateDispatch(false))
        }).catch(reason => {
            this.snackbar(
                setSnackbarDispatch(
                    SnackbarActionTypes.SHOW_ERROR,
                    "خطا در بروزرسانی رمز عبور"))
            this.loading(setLoadingStateDispatch(false))
        })
    }

    prepareManagerProfileData(firstName, lastName, userName, nationalCode, phoneNumber) {
        return {
            "firstName": firstName,
            "lastName": lastName,
            "username": userName,
            "nationalCode": nationalCode,
            "phoneNumber": phoneNumber,
        }
    }
}